import * as e from "react";
const t = (a) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...a
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 16.5a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm4.24-2.74a1 1 0 01-1.41 1.41 4 4 0 00-5.66 0 1 1 0 11-1.41-1.41 6 6 0 018.48 0zm2.83-2.83a1 1 0 01-1.41 1.41 8 8 0 00-11.32 0 1 1 0 01-1.41-1.41c3.905-3.904 10.235-3.904 14.14 0zm2.83-2.82a1 1 0 11-1.41 1.4 12 12 0 00-16.98 0 1 1 0 11-1.4-1.4c5.466-5.461 14.324-5.461 19.79 0z",
      fill: "#2d6ded"
    }
  )
), l = t;
export {
  l as default
};
